// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"55f54e89","455":"909aed07","488":"66c316c5","746":"c21f08c5","757":"7805b2b3","811":"f8e29cff","819":"55039c1d","849":"e771762f","876":"aad76651","977":"f5039bc1"}[chunkId] + ".chunk.js";
};